<template>
  <!-- COE -->
  <div class="py-5 section-aquamarine" id="coe">
    <div class="container text-center">
      <div class="row align-items-center justify-content-center" style="height:15vh;">
        <div class="col-md-12">
          <h1>CENTRO DE OPERAÇÕES EMERGÊNCIAIS</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8 text-center">
          <img class="center-block img-fluid d-block" src="@/assets/imagens/logo_coe.png">
        </div>
        <div class="col-md-4 align-self-center animate-in-right">
          <a href="https://www.toledo.pr.gov.br/coe/portarias" class="btn btn-lg btn-light my-3">Portarias</a>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center">
          <p>Contato: <a href="mailto:centrodeoperacoesemergencias@gmail.com?subject=COE-Toledo - sua pergunta?"  class="text-dark">centrodeoperacoesemergencias@gmail.com</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Bloco10Coe"
}
</script>

<style scoped>

</style>